import { useLocation } from 'react-router';

/** Screens planned for a later phase (WEB_PLAN.md §6). */
export default function ComingSoonPage({ title, phase }: { title: string; phase: number }) {
  const { pathname } = useLocation();
  return (
    <div className="mx-auto max-w-xl p-10 text-center">
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="mt-3 text-sm opacity-70">
        Coming in phase {phase} of the web console. Until then, use the Ground Team iPhone app for {pathname}.
      </p>
    </div>
  );
}
